import React from "react";
import "./ChatHome.css";

function ChatHome() {
  return (
    <div className="chatHome__container">
      <div className="logo__container">
        <img
          className="logo"
          src="https://dewey.tailorbrands.com/production/brand_version_mockup_image/757/4777403757_f562abb8-c491-4c10-9ac8-ebfb0e2d2d40.png?cb=1614763229"
          alt=""
        />
      </div>
    </div>
  );
}

export default ChatHome;
